import { Component, OnInit, OnDestroy } from '@angular/core';
import {NotificationServiceBus} from '../notification/notification.service';
import {GLOBAL} from '../shared/global';
import {SpinnerService} from '../spinner/spinner.service';
import {BookingService} from '../api/booking.service';
import {DatePipe} from '@angular/common';
import { UserService } from '../api/user.service';
import { OrganisationalRepresentative, UserFactory } from '../shared/model/user.entity';
import { SubOrganisationFilterService } from '../shared/sub-organisation-filter/sub-organisation-filter.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit, OnDestroy {
    date_from: Date;
    date_to: Date;
    exportType = '';
    allOrgs = [];
    selectedOrgs = [];
    bookingStatuses = [];
    dropdownSettings = {};
    _cbUTS = false;
    _cbCC = false;
    _cbCNC = false;
    _cbCnCl = false;
    _cbCCE = false;
    _cbCE = false;
    _cbSC = false;
    _cbCl = false;
    isExported = false;
    msIn3Months: number = 1000 /*milliseconds*/
        * 60 /*seconds*/
        * 60 /*minutes*/
        * 24 /*hours*/
        * 31 /*days*/
        * 3 /*months*/
        - 1 /*adjust days*/;

    private destroySubject = new Subject();

    constructor(public notificationServiceBus: NotificationServiceBus, public spinnerService: SpinnerService,
                public bookingService: BookingService, private datePipe: DatePipe,
                private subOrganisationFilter: SubOrganisationFilterService) { }

    ngOnInit() {
        this.dropdownSettings = {
            singleSelection: false,
            text: 'Select Organisation',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            badgeShowLimit: 1,
            classes: 'myclass custom-class'
        };
        this.subOrganisationFilter.selected$
          .pipe(takeUntil(this.destroySubject))
          .subscribe(() => {
            this.exportType = '';
            this.selectedOrgs = [];
        });
    }

    ngOnDestroy() {
      this.destroySubject.next();
    }

    exportClick(report_form) {
        if (report_form.invalid) {
            this.notificationServiceBus.launchNotification(true, 'Please select all fields');
            return;
        }
        if (!this.validateMaxDate()) {
            this.notificationServiceBus.launchNotification(true, 'The date range should be 3 months or less');
            return;
        }

        let org_ids = [];
        this.selectedOrgs.forEach(org => {
            org_ids.push(org.id);
        });

        let data = {
            'date_from': this.datePipe.transform(this.date_from, 'yyyy-MM-dd'),
            'date_to': this.datePipe.transform(this.date_to, 'yyyy-MM-dd'),
            'export_type': this.exportType,
            'organisation_ids': org_ids,
            'aasm_states': this.bookingStatuses,
            'exported' : this.isExported
        };

        this.spinnerService.requestInProcess(true);
        if (this.exportType !== 'dsq_org_monthly') {
            delete data.organisation_ids;
            delete data.aasm_states;
        }
        this.bookingService.exportBookings(data, {sub_org: this.subOrganisationFilter.selected.name})
            .subscribe((res: any) => {
                    if (res.status === 204) {
                        this.notificationServiceBus.launchNotification(false, `Export is successful. Please check your email.`);
                    }
                    this.spinnerService.requestInProcess(false);
                },
                err => {
                    this.spinnerService.requestInProcess(false);
                    let e = err.json() || 'There is an error on the server side.';
                    this.notificationServiceBus.launchNotification(true, e);
                });
    }

    private filterOrganisationList(): any {
        return this.bookingService.fetchOrganisations({sub_org: this.subOrganisationFilter.selected.name}).subscribe((res: any) => {
            this.allOrgs = res.data.organisations.map(u => {
                return {'id': u.id, 'itemName': u.name};
            });
        });
    }

    onChange() {
        if (this.exportType === 'dsq_org_monthly') {
            this.filterOrganisationList();
        }
    }

    statusChange(statusType: string, cbObj) {
        if (cbObj.name === 'cbUTS' && cbObj.checked) {
            this.bookingStatuses.push(statusType);
        } else if (cbObj.name === 'cbCC' && cbObj.checked) {
            this.bookingStatuses.push(statusType);
        } else if (cbObj.name === 'cbCNC' && cbObj.checked) {
            this.bookingStatuses.push(statusType);
        } else if (cbObj.name === 'cbCnCl' && cbObj.checked) {
            this.bookingStatuses.push(statusType);
        } else if (cbObj.name === 'cbCCE' && cbObj.checked) {
            this.bookingStatuses.push(statusType);
        } else if (cbObj.name === 'cbCE' && cbObj.checked) {
            this.bookingStatuses.push(statusType);
        } else if (cbObj.name === 'cbSC' && cbObj.checked) {
            this.bookingStatuses.push(statusType);
        } else if (cbObj.name === 'cbCl' && cbObj.checked) {
            this.bookingStatuses.push(statusType);
        } else {
            this.bookingStatuses.splice(this.bookingStatuses.indexOf(statusType), 1);
        }
    }

    isBusinessVicdeaf(): boolean {
        return (GLOBAL.currentUser.business_name === 'Vicdeaf');
    }
    validateMaxDate() {
        return (Math.abs(this.date_to.getTime() - this.date_from.getTime()) <= this.msIn3Months);
    }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts